import React from 'react';
import { css } from '@emotion/react';
// @ts-ignore NOT TS yet
import { humanizeType } from '../../services/playground/knobs';
export var EuiTheme = function EuiTheme() {
  return ___EmotionJSX("div", null);
};
export var EuiThemeColors = function EuiThemeColors() {
  return ___EmotionJSX("div", null);
};
export var EuiThemeConstantColors = function EuiThemeConstantColors() {
  return ___EmotionJSX("div", null);
};
export var EuiThemeSize = function EuiThemeSize() {
  return ___EmotionJSX("div", null);
};
export var EuiThemeFontBase = function EuiThemeFontBase() {
  return ___EmotionJSX("div", null);
};
export var EuiThemeFontWeight = function EuiThemeFontWeight() {
  return ___EmotionJSX("div", null);
};
export var EuiThemeFontScale = function EuiThemeFontScale() {
  return ___EmotionJSX("div", null);
};
export var EuiThemeBody = function EuiThemeBody() {
  return ___EmotionJSX("div", null);
};
export var EuiThemeBorderRadiusValues = function EuiThemeBorderRadiusValues() {
  return ___EmotionJSX("div", null);
};
export var EuiThemeBorderWidthValues = function EuiThemeBorderWidthValues() {
  return ___EmotionJSX("div", null);
};
export var EuiThemeBorderColorValues = function EuiThemeBorderColorValues() {
  return ___EmotionJSX("div", null);
};
export var EuiThemeBorderTypes = function EuiThemeBorderTypes() {
  return ___EmotionJSX("div", null);
};
export var EuiThemeFocus = function EuiThemeFocus() {
  return ___EmotionJSX("div", null);
};
export var EuiThemeAnimationSpeed = function EuiThemeAnimationSpeed() {
  return ___EmotionJSX("div", null);
};
export var EuiThemeAnimationEasing = function EuiThemeAnimationEasing() {
  return ___EmotionJSX("div", null);
};
export var euiThemeBreakpointType = {
  custom: {
    origin: {
      type: {
        name: 'number'
      }
    }
  }
};
export var EuiThemeLevelsProps = () => <div />;
export function getType(type, euiTheme) {
  let typeRender;
  if (type?.custom?.origin?.type) {
    typeRender = <span css={/*#__PURE__*/css("font-weight:", euiTheme.font.weight.light, ";color:", euiTheme.colors.textSubdued, ";;label:typeRender;")}>
        {humanizeType(type.custom.origin.type)}
      </span>;
  }
  return typeRender;
}
try {
  EuiTheme.__docgenInfo = {
    tags: {},
    filePath: '/app/packages/eui/src-docs/src/views/theme/_props.tsx',
    description: '',
    displayName: 'EuiTheme',
    methods: [],
    props: {
      colors: {
        defaultValue: null,
        description: '',
        name: 'colors',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/services/theme/types.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: '_EuiThemeColors'
        }
      },
      base: {
        defaultValue: null,
        description: '- Default value: 16',
        name: 'base',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/services/theme/types.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'number'
        }
      },
      size: {
        defaultValue: null,
        description: '@see {@link https ://eui.elastic.co/#/theming/sizing | Reference} for more information',
        name: 'size',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/services/theme/types.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: '_EuiThemeSizes'
        }
      },
      font: {
        defaultValue: null,
        description: '',
        name: 'font',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/services/theme/types.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: '_EuiThemeFont'
        }
      },
      border: {
        defaultValue: null,
        description: '',
        name: 'border',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/services/theme/types.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: '_EuiThemeBorder'
        }
      },
      focus: {
        defaultValue: null,
        description: '',
        name: 'focus',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/services/theme/types.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: '_EuiThemeFocus'
        }
      },
      animation: {
        defaultValue: null,
        description: '',
        name: 'animation',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/services/theme/types.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: '_EuiThemeAnimation'
        }
      },
      breakpoint: {
        defaultValue: null,
        description: '',
        name: 'breakpoint',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/services/theme/types.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: '_EuiThemeBreakpoints'
        }
      },
      levels: {
        defaultValue: null,
        description: '',
        name: 'levels',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/services/theme/types.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: '_EuiThemeLevels'
        }
      },
      components: {
        defaultValue: null,
        description: '',
        name: 'components',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/services/theme/types.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: '_EuiThemeComponents'
        }
      },
      flags: {
        defaultValue: null,
        description: '',
        name: 'flags',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/services/theme/types.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: '_EuiThemeFlags'
        }
      }
    },
    extendedInterfaces: ['_EuiThemeBody', '_EuiThemeBorderRadiusValues', '_EuiThemeBorderWidthValues', '_EuiThemeBorderColorValues', '_EuiThemeBorderTypes', '_EuiThemeFocus']
  };
} catch (e) {}
try {
  EuiThemeColors.__docgenInfo = {
    tags: {},
    filePath: '/app/packages/eui/src-docs/src/views/theme/_props.tsx',
    description: '',
    displayName: 'EuiThemeColors',
    methods: [],
    props: {
      primary: {
        defaultValue: null,
        description: 'Main brand color and used for most **call to actions** like buttons and links.',
        name: 'primary',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      accent: {
        defaultValue: null,
        description: 'Pulls attention to key indicators like **notifications** or number of selections.',
        name: 'accent',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      accentSecondary: {
        defaultValue: null,
        description: 'Secondary attention indicator with lower priority.',
        name: 'accentSecondary',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      success: {
        defaultValue: null,
        description: 'Used for **positive** messages/graphics and additive actions.',
        name: 'success',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      warning: {
        defaultValue: null,
        description: 'Used for **warnings** and actions that have a potential to be destructive.',
        name: 'warning',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      danger: {
        defaultValue: null,
        description: 'Used for **negative** messages/graphics like errors and destructive actions.',
        name: 'danger',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      primaryText: {
        defaultValue: null,
        description: 'Typically computed against `colors.primary`\n' + '@deprecated - use `textPrimary` instead',
        name: 'primaryText',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      accentText: {
        defaultValue: null,
        description: 'Typically computed against `colors.accent`\n' + '@deprecated - use `textAccent` instead',
        name: 'accentText',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      successText: {
        defaultValue: null,
        description: 'Typically computed against `colors.success`\n' + '@deprecated - use `textSuccess` instead',
        name: 'successText',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      warningText: {
        defaultValue: null,
        description: 'Typically computed against `colors.warning`\n' + '@deprecated - use `textWarning` instead',
        name: 'warningText',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      dangerText: {
        defaultValue: null,
        description: 'Typically computed against `colors.danger`\n' + '@deprecated - use `textDanger` instead',
        name: 'dangerText',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      textPrimary: {
        defaultValue: null,
        description: '',
        name: 'textPrimary',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      textAccent: {
        defaultValue: null,
        description: '',
        name: 'textAccent',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      textAccentSecondary: {
        defaultValue: null,
        description: '',
        name: 'textAccentSecondary',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      textSuccess: {
        defaultValue: null,
        description: '',
        name: 'textSuccess',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      textWarning: {
        defaultValue: null,
        description: '',
        name: 'textWarning',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      textDanger: {
        defaultValue: null,
        description: '',
        name: 'textDanger',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      emptyShade: {
        defaultValue: null,
        description: 'Used as the background color of primary **page content and panels** including modals and flyouts.\n' + '@deprecated - use specific semantic color tokens instead',
        name: 'emptyShade',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      lightestShade: {
        defaultValue: null,
        description: 'Used to lightly shade areas that contain **secondary content** or contain panel-like components.\n' + '@deprecated - use specific semantic color tokens instead',
        name: 'lightestShade',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      lightShade: {
        defaultValue: null,
        description: 'Used for most **borders** and dividers (horizontal rules).\n' + '@deprecated - use specific semantic color tokens instead',
        name: 'lightShade',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      mediumShade: {
        defaultValue: null,
        description: 'The middle gray for all themes; this is the base for `colors.subdued`.\n' + '@deprecated - use specific semantic color tokens instead',
        name: 'mediumShade',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      darkShade: {
        defaultValue: null,
        description: 'Slightly subtle graphic color\n' + '@deprecated - use specific semantic color tokens instead',
        name: 'darkShade',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      darkestShade: {
        defaultValue: null,
        description: 'Used as the **text** color and the background color for **inverted components** like tooltips and the control bar.\n' + '@deprecated - use specific semantic color tokens instead',
        name: 'darkestShade',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      fullShade: {
        defaultValue: null,
        description: 'The opposite of `emptyShade`\n' + '@deprecated - use specific semantic color tokens instead',
        name: 'fullShade',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      body: {
        defaultValue: null,
        description: 'The background color for the **whole window (body)** and is a computed value of `colors.lightestShade`.\n' + 'Provides denominator (background) value for **contrast calculations**.\n' + '@deprecated - use backgroundBasePlain or backgroundBaseSubdued instead',
        name: 'body',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      highlight: {
        defaultValue: null,
        description: 'Used to **highlight text** when matching against search strings',
        name: 'highlight',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      disabled: {
        defaultValue: null,
        description: 'Computed against `colors.darkestShade`\n' + '@deprecated - use specific semantic tokens instead (e.g. backgroundBaseDisabled, borderBaseDisabled etc)',
        name: 'disabled',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      disabledText: {
        defaultValue: null,
        description: 'Computed against `colors.disabled`\n' + '@deprecated - use textDisabled instead',
        name: 'disabledText',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      shadow: {
        defaultValue: null,
        description: 'The base color for shadows that gets `transparentized`\n' + 'at a value based on the `colorMode` and then layered.',
        name: 'shadow',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      text: {
        defaultValue: null,
        description: 'Computed against `colors.darkestShade`\n' + '@deprecated - use `textParagraph` instead',
        name: 'text',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      title: {
        defaultValue: null,
        description: 'Computed against `colors.text`\n@deprecated - use `textHeading` instead',
        name: 'title',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      subduedText: {
        defaultValue: null,
        description: 'Computed against `colors.mediumShade`\n' + '@deprecated - use `textSubdued` instead',
        name: 'subduedText',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      link: {
        defaultValue: null,
        description: 'Computed against `colors.textPrimary`',
        name: 'link',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      textParagraph: {
        defaultValue: null,
        description: '',
        name: 'textParagraph',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      textHeading: {
        defaultValue: null,
        description: '',
        name: 'textHeading',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      textSubdued: {
        defaultValue: null,
        description: '',
        name: 'textSubdued',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      textDisabled: {
        defaultValue: null,
        description: '',
        name: 'textDisabled',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      textInverse: {
        defaultValue: null,
        description: '',
        name: 'textInverse',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      backgroundBasePrimary: {
        defaultValue: null,
        description: '',
        name: 'backgroundBasePrimary',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      backgroundBaseAccent: {
        defaultValue: null,
        description: '',
        name: 'backgroundBaseAccent',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      backgroundBaseAccentSecondary: {
        defaultValue: null,
        description: '',
        name: 'backgroundBaseAccentSecondary',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      backgroundBaseSuccess: {
        defaultValue: null,
        description: '',
        name: 'backgroundBaseSuccess',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      backgroundBaseWarning: {
        defaultValue: null,
        description: '',
        name: 'backgroundBaseWarning',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      backgroundBaseDanger: {
        defaultValue: null,
        description: '',
        name: 'backgroundBaseDanger',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      backgroundBaseSubdued: {
        defaultValue: null,
        description: '',
        name: 'backgroundBaseSubdued',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      backgroundBasePlain: {
        defaultValue: null,
        description: '',
        name: 'backgroundBasePlain',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      backgroundBaseDisabled: {
        defaultValue: null,
        description: '',
        name: 'backgroundBaseDisabled',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      backgroundBaseHighlighted: {
        defaultValue: null,
        description: '',
        name: 'backgroundBaseHighlighted',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      backgroundBaseFormsPrepend: {
        defaultValue: null,
        description: '',
        name: 'backgroundBaseFormsPrepend',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      backgroundBaseFormsControlDisabled: {
        defaultValue: null,
        description: '',
        name: 'backgroundBaseFormsControlDisabled',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      backgroundBaseInteractiveHover: {
        defaultValue: null,
        description: '',
        name: 'backgroundBaseInteractiveHover',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      backgroundBaseInteractiveSelect: {
        defaultValue: null,
        description: '',
        name: 'backgroundBaseInteractiveSelect',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      backgroundBaseInteractiveOverlay: {
        defaultValue: null,
        description: '',
        name: 'backgroundBaseInteractiveOverlay',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      backgroundBaseSkeletonEdge: {
        defaultValue: null,
        description: '',
        name: 'backgroundBaseSkeletonEdge',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      backgroundBaseSkeletonMiddle: {
        defaultValue: null,
        description: '',
        name: 'backgroundBaseSkeletonMiddle',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      backgroundLightPrimary: {
        defaultValue: null,
        description: '',
        name: 'backgroundLightPrimary',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      backgroundLightAccent: {
        defaultValue: null,
        description: '',
        name: 'backgroundLightAccent',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      backgroundLightAccentSecondary: {
        defaultValue: null,
        description: '',
        name: 'backgroundLightAccentSecondary',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      backgroundLightSuccess: {
        defaultValue: null,
        description: '',
        name: 'backgroundLightSuccess',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      backgroundLightWarning: {
        defaultValue: null,
        description: '',
        name: 'backgroundLightWarning',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      backgroundLightDanger: {
        defaultValue: null,
        description: '',
        name: 'backgroundLightDanger',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      backgroundLightText: {
        defaultValue: null,
        description: '',
        name: 'backgroundLightText',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      backgroundFilledPrimary: {
        defaultValue: null,
        description: '',
        name: 'backgroundFilledPrimary',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      backgroundFilledAccent: {
        defaultValue: null,
        description: '',
        name: 'backgroundFilledAccent',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      backgroundFilledAccentSecondary: {
        defaultValue: null,
        description: '',
        name: 'backgroundFilledAccentSecondary',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      backgroundFilledSuccess: {
        defaultValue: null,
        description: '',
        name: 'backgroundFilledSuccess',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      backgroundFilledWarning: {
        defaultValue: null,
        description: '',
        name: 'backgroundFilledWarning',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      backgroundFilledDanger: {
        defaultValue: null,
        description: '',
        name: 'backgroundFilledDanger',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      backgroundFilledText: {
        defaultValue: null,
        description: '',
        name: 'backgroundFilledText',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      backgroundTransparent: {
        defaultValue: null,
        description: '@deprecated - temp. token, was never in use',
        name: 'backgroundTransparent',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'string'
        }
      },
      backgroundTransparentPrimary: {
        defaultValue: null,
        description: '@deprecated - temp. token, was never in use',
        name: 'backgroundTransparentPrimary',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      backgroundTransparentAccent: {
        defaultValue: null,
        description: '@deprecated - temp. token, was never in use',
        name: 'backgroundTransparentAccent',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      backgroundTransparentAccentSecondary: {
        defaultValue: null,
        description: '@deprecated - temp. token, was never in use',
        name: 'backgroundTransparentAccentSecondary',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      backgroundTransparentSuccess: {
        defaultValue: null,
        description: '@deprecated - temp. token, was never in use',
        name: 'backgroundTransparentSuccess',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      backgroundTransparentWarning: {
        defaultValue: null,
        description: '@deprecated - temp. token, was never in use',
        name: 'backgroundTransparentWarning',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      backgroundTransparentDanger: {
        defaultValue: null,
        description: '@deprecated - temp. token, was never in use',
        name: 'backgroundTransparentDanger',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      backgroundTransparentSubdued: {
        defaultValue: null,
        description: '@deprecated - temp. token, was never in use',
        name: 'backgroundTransparentSubdued',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      backgroundTransparentHighlighted: {
        defaultValue: null,
        description: '@deprecated - temp. token, was never in use',
        name: 'backgroundTransparentHighlighted',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      backgroundTransparentPlain: {
        defaultValue: null,
        description: '@deprecated - temp. token, was never in use',
        name: 'backgroundTransparentPlain',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      borderBasePrimary: {
        defaultValue: null,
        description: '',
        name: 'borderBasePrimary',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      borderBaseAccent: {
        defaultValue: null,
        description: '',
        name: 'borderBaseAccent',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      borderBaseAccentSecondary: {
        defaultValue: null,
        description: '',
        name: 'borderBaseAccentSecondary',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      borderBaseSuccess: {
        defaultValue: null,
        description: '',
        name: 'borderBaseSuccess',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      borderBaseWarning: {
        defaultValue: null,
        description: '',
        name: 'borderBaseWarning',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      borderBaseDanger: {
        defaultValue: null,
        description: '',
        name: 'borderBaseDanger',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      borderBasePlain: {
        defaultValue: null,
        description: '',
        name: 'borderBasePlain',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      borderBaseSubdued: {
        defaultValue: null,
        description: '',
        name: 'borderBaseSubdued',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      borderBaseDisabled: {
        defaultValue: null,
        description: '',
        name: 'borderBaseDisabled',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      borderBaseFloating: {
        defaultValue: null,
        description: 'Border used for floating elements on dark mode (e.g. popovers or tooltips)\n' + 'to increase the contrast with the background.',
        name: 'borderBaseFloating',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      borderBaseFormsColorSwatch: {
        defaultValue: null,
        description: '',
        name: 'borderBaseFormsColorSwatch',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      borderBaseFormsControl: {
        defaultValue: null,
        description: '',
        name: 'borderBaseFormsControl',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      borderStrongPrimary: {
        defaultValue: null,
        description: '',
        name: 'borderStrongPrimary',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      borderStrongAccent: {
        defaultValue: null,
        description: '',
        name: 'borderStrongAccent',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      borderStrongAccentSecondary: {
        defaultValue: null,
        description: '',
        name: 'borderStrongAccentSecondary',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      borderStrongSuccess: {
        defaultValue: null,
        description: '',
        name: 'borderStrongSuccess',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      borderStrongWarning: {
        defaultValue: null,
        description: '',
        name: 'borderStrongWarning',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      borderStrongDanger: {
        defaultValue: null,
        description: '',
        name: 'borderStrongDanger',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      }
    },
    extendedInterfaces: ['_EuiThemeBody', '_EuiThemeBorderRadiusValues', '_EuiThemeBorderWidthValues', '_EuiThemeBorderColorValues', '_EuiThemeBorderTypes', '_EuiThemeFocus']
  };
} catch (e) {}
try {
  EuiThemeConstantColors.__docgenInfo = {
    tags: {},
    filePath: '/app/packages/eui/src-docs/src/views/theme/_props.tsx',
    description: '',
    displayName: 'EuiThemeConstantColors',
    methods: [],
    props: {
      ghost: {
        defaultValue: null,
        description: 'Purest **white**\n@deprecated',
        name: 'ghost',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'string'
        }
      },
      ink: {
        defaultValue: null,
        description: 'Purest **black**\n@deprecated',
        name: 'ink',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'string'
        }
      },
      plainLight: {
        defaultValue: null,
        description: '',
        name: 'plainLight',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'string'
        }
      },
      plainDark: {
        defaultValue: null,
        description: '',
        name: 'plainDark',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'string'
        }
      },
      vis: {
        defaultValue: null,
        description: '',
        name: 'vis',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/colors.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: '_EuiThemeVisColors'
        }
      }
    },
    extendedInterfaces: ['_EuiThemeBody', '_EuiThemeBorderRadiusValues', '_EuiThemeBorderWidthValues', '_EuiThemeBorderColorValues', '_EuiThemeBorderTypes', '_EuiThemeFocus']
  };
} catch (e) {}
try {
  EuiThemeSize.__docgenInfo = {
    tags: {},
    filePath: '/app/packages/eui/src-docs/src/views/theme/_props.tsx',
    description: '',
    displayName: 'EuiThemeSize',
    methods: [],
    props: {
      xxs: {
        defaultValue: null,
        description: '- Default value: 2px',
        name: 'xxs',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/size.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'string'
        }
      },
      xs: {
        defaultValue: null,
        description: '- Default value: 4px',
        name: 'xs',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/size.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'string'
        }
      },
      s: {
        defaultValue: null,
        description: '- Default value: 8px',
        name: 's',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/size.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'string'
        }
      },
      m: {
        defaultValue: null,
        description: '- Default value: 12px',
        name: 'm',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/size.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'string'
        }
      },
      base: {
        defaultValue: null,
        description: '- Default value: 16px',
        name: 'base',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/size.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'string'
        }
      },
      l: {
        defaultValue: null,
        description: '- Default value: 24px',
        name: 'l',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/size.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'string'
        }
      },
      xl: {
        defaultValue: null,
        description: '- Default value: 32px',
        name: 'xl',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/size.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'string'
        }
      },
      xxl: {
        defaultValue: null,
        description: '- Default value: 40px',
        name: 'xxl',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/size.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'string'
        }
      },
      xxxl: {
        defaultValue: null,
        description: '- Default value: 48px',
        name: 'xxxl',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/size.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'string'
        }
      },
      xxxxl: {
        defaultValue: null,
        description: '- Default value: 64px',
        name: 'xxxxl',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/size.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'string'
        }
      }
    },
    extendedInterfaces: ['_EuiThemeBody', '_EuiThemeBorderRadiusValues', '_EuiThemeBorderWidthValues', '_EuiThemeBorderColorValues', '_EuiThemeBorderTypes', '_EuiThemeFocus']
  };
} catch (e) {}
try {
  EuiThemeFontBase.__docgenInfo = {
    tags: {},
    filePath: '/app/packages/eui/src-docs/src/views/theme/_props.tsx',
    description: '',
    displayName: 'EuiThemeFontBase',
    methods: [],
    props: {
      family: {
        defaultValue: null,
        description: 'The whole font family stack for all parts of the UI.\n' + 'We encourage only customizing the first font in the stack.',
        name: 'family',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/typography.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'string'
        }
      },
      familyCode: {
        defaultValue: null,
        description: 'The font family used for monospace UI elements like EuiCode',
        name: 'familyCode',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/typography.d.ts',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      familySerif: {
        defaultValue: null,
        description: 'The font family used for serif UI elements like blockquotes within EuiText',
        name: 'familySerif',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/typography.d.ts',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      featureSettings: {
        defaultValue: null,
        description: 'Controls advanced features OpenType fonts.\n' + 'https://developer.mozilla.org/en-US/docs/Web/CSS/font-feature-settings',
        name: 'featureSettings',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/typography.d.ts',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      defaultUnits: {
        defaultValue: {
          value: "'rem'"
        },
        description: 'Sets the default units used for font size & line height set by UI components\n' + 'like EuiText or EuiTitle. Defaults to `rem`.\n' + '\n' + 'NOTE: This may overridden by some internal usages, e.g.\n' + "EuiText's `relative` size which must use `em`.",
        name: 'defaultUnits',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/typography.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'enum',
          raw: '"em" | "rem" | "px"',
          value: [{
            value: '"em"'
          }, {
            value: '"rem"'
          }, {
            value: '"px"'
          }]
        }
      },
      baseline: {
        defaultValue: null,
        description: 'A computed number that is 1/4 of `base`',
        name: 'baseline',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/typography.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'number'
        }
      },
      lineHeightMultiplier: {
        defaultValue: null,
        description: 'Establishes the ideal line-height percentage, but it is the `baseline` integer that establishes the final pixel/rem value',
        name: 'lineHeightMultiplier',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/typography.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'number'
        }
      }
    },
    extendedInterfaces: ['_EuiThemeBody', '_EuiThemeBorderRadiusValues', '_EuiThemeBorderWidthValues', '_EuiThemeBorderColorValues', '_EuiThemeBorderTypes', '_EuiThemeFocus']
  };
} catch (e) {}
try {
  EuiThemeFontWeight.__docgenInfo = {
    tags: {},
    filePath: '/app/packages/eui/src-docs/src/views/theme/_props.tsx',
    description: '',
    displayName: 'EuiThemeFontWeight',
    methods: [],
    props: {
      light: {
        defaultValue: null,
        description: '- Default value: 300',
        name: 'light',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/typography.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'FontWeight'
        }
      },
      regular: {
        defaultValue: null,
        description: '- Default value: 400',
        name: 'regular',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/typography.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'FontWeight'
        }
      },
      medium: {
        defaultValue: null,
        description: '- Default value: 500',
        name: 'medium',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/typography.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'FontWeight'
        }
      },
      semiBold: {
        defaultValue: null,
        description: '- Default value: 600',
        name: 'semiBold',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/typography.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'FontWeight'
        }
      },
      bold: {
        defaultValue: null,
        description: '- Default value: 700',
        name: 'bold',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/typography.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'FontWeight'
        }
      }
    },
    extendedInterfaces: ['_EuiThemeBody', '_EuiThemeBorderRadiusValues', '_EuiThemeBorderWidthValues', '_EuiThemeBorderColorValues', '_EuiThemeBorderTypes', '_EuiThemeFocus']
  };
} catch (e) {}
try {
  EuiThemeFontScale.__docgenInfo = {
    tags: {},
    filePath: '/app/packages/eui/src-docs/src/views/theme/_props.tsx',
    description: '',
    displayName: 'EuiThemeFontScale',
    methods: [],
    props: {
      s: {
        defaultValue: null,
        description: '',
        name: 's',
        parent: undefined,
        declarations: undefined,
        required: true,
        type: {
          name: 'number'
        }
      },
      m: {
        defaultValue: null,
        description: '',
        name: 'm',
        parent: undefined,
        declarations: undefined,
        required: true,
        type: {
          name: 'number'
        }
      },
      xs: {
        defaultValue: null,
        description: '',
        name: 'xs',
        parent: undefined,
        declarations: undefined,
        required: true,
        type: {
          name: 'number'
        }
      },
      l: {
        defaultValue: null,
        description: '',
        name: 'l',
        parent: undefined,
        declarations: undefined,
        required: true,
        type: {
          name: 'number'
        }
      },
      xl: {
        defaultValue: null,
        description: '',
        name: 'xl',
        parent: undefined,
        declarations: undefined,
        required: true,
        type: {
          name: 'number'
        }
      },
      xxl: {
        defaultValue: null,
        description: '',
        name: 'xxl',
        parent: undefined,
        declarations: undefined,
        required: true,
        type: {
          name: 'number'
        }
      },
      xxxs: {
        defaultValue: null,
        description: '',
        name: 'xxxs',
        parent: undefined,
        declarations: undefined,
        required: true,
        type: {
          name: 'number'
        }
      },
      xxs: {
        defaultValue: null,
        description: '',
        name: 'xxs',
        parent: undefined,
        declarations: undefined,
        required: true,
        type: {
          name: 'number'
        }
      }
    },
    extendedInterfaces: ['_EuiThemeBody', '_EuiThemeBorderRadiusValues', '_EuiThemeBorderWidthValues', '_EuiThemeBorderColorValues', '_EuiThemeBorderTypes', '_EuiThemeFocus']
  };
} catch (e) {}
try {
  EuiThemeBody.__docgenInfo = {
    tags: {},
    filePath: '/app/packages/eui/src-docs/src/views/theme/_props.tsx',
    description: '',
    displayName: 'EuiThemeBody',
    methods: [],
    props: {
      scale: {
        defaultValue: null,
        description: 'A sizing key from one of the font scales to set as the base body font-size',
        name: 'scale',
        parent: {
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/typography.d.ts',
          name: '_EuiThemeBody'
        },
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/typography.d.ts',
          name: '_EuiThemeBody'
        }],
        required: true,
        type: {
          name: 'enum',
          raw: '"s" | "m" | "xs" | "l" | "xl" | "xxl" | "xxxs" | "xxs"',
          value: [{
            value: '"s"'
          }, {
            value: '"m"'
          }, {
            value: '"xs"'
          }, {
            value: '"l"'
          }, {
            value: '"xl"'
          }, {
            value: '"xxl"'
          }, {
            value: '"xxxs"'
          }, {
            value: '"xxs"'
          }]
        }
      },
      weight: {
        defaultValue: null,
        description: 'A font weight key for setting the base body weight',
        name: 'weight',
        parent: {
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/typography.d.ts',
          name: '_EuiThemeBody'
        },
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/typography.d.ts',
          name: '_EuiThemeBody'
        }],
        required: true,
        type: {
          name: 'enum',
          raw: 'keyof _EuiThemeFontWeights',
          value: [{
            value: '"light"'
          }, {
            value: '"bold"'
          }, {
            value: '"regular"'
          }, {
            value: '"medium"'
          }, {
            value: '"semiBold"'
          }]
        }
      }
    },
    extendedInterfaces: ['_EuiThemeBody', '_EuiThemeBorderRadiusValues', '_EuiThemeBorderWidthValues', '_EuiThemeBorderColorValues', '_EuiThemeBorderTypes', '_EuiThemeFocus']
  };
} catch (e) {}
try {
  EuiThemeBorderRadiusValues.__docgenInfo = {
    tags: {},
    filePath: '/app/packages/eui/src-docs/src/views/theme/_props.tsx',
    description: '',
    displayName: 'EuiThemeBorderRadiusValues',
    methods: [],
    props: {
      medium: {
        defaultValue: null,
        description: 'Primary corner radius size\n- Default value: 4px (6px in Amsterdam)',
        name: 'medium',
        parent: {
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/borders.d.ts',
          name: '_EuiThemeBorderRadiusValues'
        },
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/borders.d.ts',
          name: '_EuiThemeBorderRadiusValues'
        }],
        required: true,
        type: {
          name: 'BorderRadius<string | number>'
        }
      },
      small: {
        defaultValue: null,
        description: 'Small corner radius size\n- Default value: 4px',
        name: 'small',
        parent: {
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/borders.d.ts',
          name: '_EuiThemeBorderRadiusValues'
        },
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/borders.d.ts',
          name: '_EuiThemeBorderRadiusValues'
        }],
        required: true,
        type: {
          name: 'BorderRadius<string | number>'
        }
      }
    },
    extendedInterfaces: ['_EuiThemeBody', '_EuiThemeBorderRadiusValues', '_EuiThemeBorderWidthValues', '_EuiThemeBorderColorValues', '_EuiThemeBorderTypes', '_EuiThemeFocus']
  };
} catch (e) {}
try {
  EuiThemeBorderWidthValues.__docgenInfo = {
    tags: {},
    filePath: '/app/packages/eui/src-docs/src/views/theme/_props.tsx',
    description: '',
    displayName: 'EuiThemeBorderWidthValues',
    methods: [],
    props: {
      thin: {
        defaultValue: null,
        description: 'Thinnest width for border\n- Default value: 1px',
        name: 'thin',
        parent: {
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/borders.d.ts',
          name: '_EuiThemeBorderWidthValues'
        },
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/borders.d.ts',
          name: '_EuiThemeBorderWidthValues'
        }],
        required: true,
        type: {
          name: 'BorderWidth<string | number>'
        }
      },
      thick: {
        defaultValue: null,
        description: 'Thickest width for border\n- Default value: 2px',
        name: 'thick',
        parent: {
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/borders.d.ts',
          name: '_EuiThemeBorderWidthValues'
        },
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/borders.d.ts',
          name: '_EuiThemeBorderWidthValues'
        }],
        required: true,
        type: {
          name: 'BorderWidth<string | number>'
        }
      }
    },
    extendedInterfaces: ['_EuiThemeBody', '_EuiThemeBorderRadiusValues', '_EuiThemeBorderWidthValues', '_EuiThemeBorderColorValues', '_EuiThemeBorderTypes', '_EuiThemeFocus']
  };
} catch (e) {}
try {
  EuiThemeBorderColorValues.__docgenInfo = {
    tags: {},
    filePath: '/app/packages/eui/src-docs/src/views/theme/_props.tsx',
    description: '',
    displayName: 'EuiThemeBorderColorValues',
    methods: [],
    props: {
      color: {
        defaultValue: null,
        description: 'Color for all borders; Default is `colors.lightShade`.\n' + 'In high contrast mode, this value becomes `colors.fullShade` and cannot be overridden.',
        name: 'color',
        parent: {
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/borders.d.ts',
          name: '_EuiThemeBorderColorValues'
        },
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/borders.d.ts',
          name: '_EuiThemeBorderColorValues'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      }
    },
    extendedInterfaces: ['_EuiThemeBody', '_EuiThemeBorderRadiusValues', '_EuiThemeBorderWidthValues', '_EuiThemeBorderColorValues', '_EuiThemeBorderTypes', '_EuiThemeFocus']
  };
} catch (e) {}
try {
  EuiThemeBorderTypes.__docgenInfo = {
    tags: {},
    filePath: '/app/packages/eui/src-docs/src/views/theme/_props.tsx',
    description: '',
    displayName: 'EuiThemeBorderTypes',
    methods: [],
    props: {
      thin: {
        defaultValue: null,
        description: 'Full `border` property string computed using `border.width.thin` and `border.color`\n' + '- Default value: 1px solid [colors.lightShade]',
        name: 'thin',
        parent: {
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/borders.d.ts',
          name: '_EuiThemeBorderTypes'
        },
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/borders.d.ts',
          name: '_EuiThemeBorderTypes'
        }],
        required: true,
        type: {
          name: 'Border<string | number>'
        }
      },
      thick: {
        defaultValue: null,
        description: 'Full `border` property string computed using `border.width.thick` and `border.color`\n' + '- Default value: 2px solid [colors.lightShade]',
        name: 'thick',
        parent: {
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/borders.d.ts',
          name: '_EuiThemeBorderTypes'
        },
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/borders.d.ts',
          name: '_EuiThemeBorderTypes'
        }],
        required: true,
        type: {
          name: 'Border<string | number>'
        }
      },
      editable: {
        defaultValue: null,
        description: 'Full editable style `border` property string computed using `border.width.thick` and `border.color`\n' + '- Default value: 2px dotted [colors.lightShade]',
        name: 'editable',
        parent: {
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/borders.d.ts',
          name: '_EuiThemeBorderTypes'
        },
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/borders.d.ts',
          name: '_EuiThemeBorderTypes'
        }],
        required: true,
        type: {
          name: 'Border<string | number>'
        }
      }
    },
    extendedInterfaces: ['_EuiThemeBody', '_EuiThemeBorderRadiusValues', '_EuiThemeBorderWidthValues', '_EuiThemeBorderColorValues', '_EuiThemeBorderTypes', '_EuiThemeFocus']
  };
} catch (e) {}
try {
  EuiThemeFocus.__docgenInfo = {
    tags: {},
    filePath: '/app/packages/eui/src-docs/src/views/theme/_props.tsx',
    description: '',
    displayName: 'EuiThemeFocus',
    methods: [],
    props: {
      color: {
        defaultValue: null,
        description: 'Default color of the focus ring, some components may override this property\n' + '- Default value: currentColor',
        name: 'color',
        parent: {
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/states.d.ts',
          name: '_EuiThemeFocus'
        },
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/states.d.ts',
          name: '_EuiThemeFocus'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      },
      width: {
        defaultValue: null,
        description: 'Thickness of the outline\n- Default value: 2px',
        name: 'width',
        parent: {
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/states.d.ts',
          name: '_EuiThemeFocus'
        },
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/states.d.ts',
          name: '_EuiThemeFocus'
        }],
        required: true,
        type: {
          name: 'BorderWidth<string | number>'
        }
      },
      transparency: {
        defaultValue: null,
        description: 'Used to transparentize the focus background color\n' + '- Default value: { LIGHT: 0.1, DARK: 0.2 }',
        name: 'transparency',
        parent: {
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/states.d.ts',
          name: '_EuiThemeFocus'
        },
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/states.d.ts',
          name: '_EuiThemeFocus'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<number>'
        }
      },
      backgroundColor: {
        defaultValue: null,
        description: 'Default focus background color. Not all components set a background color on focus\n' + '- Default value: `colors.primary` computed with `focus.transparency`',
        name: 'backgroundColor',
        parent: {
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/states.d.ts',
          name: '_EuiThemeFocus'
        },
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/states.d.ts',
          name: '_EuiThemeFocus'
        }],
        required: true,
        type: {
          name: 'ColorModeSwitch<string>'
        }
      }
    },
    extendedInterfaces: ['_EuiThemeBody', '_EuiThemeBorderRadiusValues', '_EuiThemeBorderWidthValues', '_EuiThemeBorderColorValues', '_EuiThemeBorderTypes', '_EuiThemeFocus']
  };
} catch (e) {}
try {
  EuiThemeAnimationSpeed.__docgenInfo = {
    tags: {},
    filePath: '/app/packages/eui/src-docs/src/views/theme/_props.tsx',
    description: '',
    displayName: 'EuiThemeAnimationSpeed',
    methods: [],
    props: {
      extraFast: {
        defaultValue: null,
        description: '- Default value: 90ms',
        name: 'extraFast',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/animations.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'AnimationDuration<string & {}>'
        }
      },
      fast: {
        defaultValue: null,
        description: '- Default value: 150ms',
        name: 'fast',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/animations.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'AnimationDuration<string & {}>'
        }
      },
      normal: {
        defaultValue: null,
        description: '- Default value: 250ms',
        name: 'normal',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/animations.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'AnimationDuration<string & {}>'
        }
      },
      slow: {
        defaultValue: null,
        description: '- Default value: 350ms',
        name: 'slow',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/animations.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'AnimationDuration<string & {}>'
        }
      },
      extraSlow: {
        defaultValue: null,
        description: '- Default value: 500ms',
        name: 'extraSlow',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/animations.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'AnimationDuration<string & {}>'
        }
      }
    },
    extendedInterfaces: ['_EuiThemeBody', '_EuiThemeBorderRadiusValues', '_EuiThemeBorderWidthValues', '_EuiThemeBorderColorValues', '_EuiThemeBorderTypes', '_EuiThemeFocus']
  };
} catch (e) {}
try {
  EuiThemeAnimationEasing.__docgenInfo = {
    tags: {},
    filePath: '/app/packages/eui/src-docs/src/views/theme/_props.tsx',
    description: '',
    displayName: 'EuiThemeAnimationEasing',
    methods: [],
    props: {
      bounce: {
        defaultValue: null,
        description: '',
        name: 'bounce',
        parent: undefined,
        declarations: undefined,
        required: true,
        type: {
          name: 'AnimationTimingFunction'
        }
      },
      resistance: {
        defaultValue: null,
        description: '',
        name: 'resistance',
        parent: undefined,
        declarations: undefined,
        required: true,
        type: {
          name: 'AnimationTimingFunction'
        }
      }
    },
    extendedInterfaces: ['_EuiThemeBody', '_EuiThemeBorderRadiusValues', '_EuiThemeBorderWidthValues', '_EuiThemeBorderColorValues', '_EuiThemeBorderTypes', '_EuiThemeFocus']
  };
} catch (e) {}
try {
  EuiThemeLevelsProps.__docgenInfo = {
    tags: {},
    filePath: '/app/packages/eui/src-docs/src/views/theme/_props.tsx',
    description: '',
    displayName: 'EuiThemeLevelsProps',
    methods: [],
    props: {
      toast: {
        defaultValue: null,
        description: '- Default value: 9000',
        name: 'toast',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/levels.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ZIndex'
        }
      },
      modal: {
        defaultValue: null,
        description: '- Default value: 8000',
        name: 'modal',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/levels.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ZIndex'
        }
      },
      mask: {
        defaultValue: null,
        description: '- Default value: 6000',
        name: 'mask',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/levels.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ZIndex'
        }
      },
      navigation: {
        defaultValue: null,
        description: '- Default value: 6000',
        name: 'navigation',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/levels.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ZIndex'
        }
      },
      menu: {
        defaultValue: null,
        description: '- Default value: 2000',
        name: 'menu',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/levels.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ZIndex'
        }
      },
      header: {
        defaultValue: null,
        description: '- Default value: 1000',
        name: 'header',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/levels.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ZIndex'
        }
      },
      flyout: {
        defaultValue: null,
        description: '- Default value: 1000',
        name: 'flyout',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/levels.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ZIndex'
        }
      },
      maskBelowHeader: {
        defaultValue: null,
        description: '- Default value: 1000',
        name: 'maskBelowHeader',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/levels.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ZIndex'
        }
      },
      content: {
        defaultValue: null,
        description: '- Default value: 0',
        name: 'content',
        parent: undefined,
        declarations: [{
          fileName: 'eui-theme-common/lib/cjs/global_styling/variables/levels.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ZIndex'
        }
      }
    },
    extendedInterfaces: ['_EuiThemeBody', '_EuiThemeBorderRadiusValues', '_EuiThemeBorderWidthValues', '_EuiThemeBorderColorValues', '_EuiThemeBorderTypes', '_EuiThemeFocus']
  };
} catch (e) {}